import React from "react";
import JobPostListItem from "./JobPostListItem";
import sortBy from "lodash/sortBy";
import { Segment } from "semantic-ui-react";
import { SEMANTIC_DIV } from "../../../css/styles";

export default function CurrentJobPostsList({
  jobs,
  heading,
  noJobsMessage,
  editable = true,
  preview = true,
  repost = false,
  stats = true,
  applicants = false,
  handleSetApplicantsView = () => {},
  handleSetStatsView = () => {},
  type,
  isAdmin = false,
  loading = false,
  mainButton = "",
  isShowMenu = true,
}) {
  const sortedViaPublishedDateJobs = sortBy(jobs, "datePublished").reverse();

  return (
    <div className="manage-job-list">
      <Segment basic style={{ ...SEMANTIC_DIV }} disabled={loading}>
        <div className="body-bold-text">{heading}</div>
        <div className="manage-job-list-container">
          {sortedViaPublishedDateJobs.length > 0 && (
            <div>
              {sortedViaPublishedDateJobs.filter((job) => job.isActive).length >
              0 ? (
                <div style={{ marginBottom: 29 }}>
                  <div className="body-bold-text" style={{ marginBottom: 16 }}>
                    Active
                  </div>
                  {sortedViaPublishedDateJobs
                    .filter((job) => job.isActive)
                    .map((job) => (
                      <JobPostListItem
                        job={job}
                        key={job.id}
                        editable={editable}
                        stats={stats}
                        repost={repost}
                        applicants={applicants}
                        handleSetApplicantsView={handleSetApplicantsView}
                        handleSetStatsView={handleSetStatsView}
                        type={type}
                        isAdmin={isAdmin}
                        preview={preview}
                        mainButton={mainButton}
                        isShowMenu={isShowMenu}
                      />
                    ))}
                </div>
              ) : (
                <div style={{ marginBottom: 22 }}>
                  <span className="manage-item-list-no-item">
                    No active jobs
                  </span>
                </div>
              )}
              {sortedViaPublishedDateJobs.filter((job) => !job.isActive)
                .length > 0 ? (
                <div>
                  <div className="body-bold-text" style={{ marginBottom: 16 }}>
                    Inactive
                  </div>
                  {sortedViaPublishedDateJobs
                    .filter((job) => !job.isActive)
                    .map((job) => (
                      <JobPostListItem
                        job={job}
                        key={job.id}
                        editable={editable}
                        type={type}
                        isAdmin={isAdmin}
                        preview={preview}
                        stats={stats}
                        applicants={applicants}
                        handleSetApplicantsView={handleSetApplicantsView}
                        handleSetStatsView={handleSetStatsView}
                        mainButton={mainButton}
                        isShowMenu={isShowMenu}
                      />
                    ))}
                </div>
              ) : (
                <div>
                  <span className="manage-item-list-no-item">
                    No inactive jobs
                  </span>
                </div>
              )}
            </div>
          )}
          {sortedViaPublishedDateJobs.length === 0 && (
            <span className="manage-item-list-no-item">{noJobsMessage}</span>
          )}
        </div>
      </Segment>
    </div>
  );
}
